import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import { store } from "../lib/storage";

const KEY = "smarti_compare";
const MAX = 3;
const CompareContext = createContext(null);

function load() {
  try {
    const raw = store.get(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function CompareProvider({ children }) {
  const [items, setItems] = useState(load);

  useEffect(() => {
    store.set(KEY, JSON.stringify(items));
  }, [items]);

  const has = useCallback((slug) => items.some((i) => i.slug === slug), [items]);

  const toggle = useCallback((p) => {
    setItems((prev) => {
      if (prev.some((i) => i.slug === p.slug)) return prev.filter((i) => i.slug !== p.slug);
      if (prev.length >= MAX) return prev;
      return [...prev, { slug: p.slug, name: p.name, image: (p.images || [])[0] || (p.colors || []).find((c) => c.images?.length)?.images?.[0] }];
    });
  }, []);

  const remove = useCallback((slug) => setItems((prev) => prev.filter((i) => i.slug !== slug)), []);
  const clear = useCallback(() => setItems([]), []);

  return (
    <CompareContext.Provider value={{ items, has, toggle, remove, clear, max: MAX, full: items.length >= MAX }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const ctx = useContext(CompareContext);
  if (!ctx) return { items: [], has: () => false, toggle: () => {}, remove: () => {}, clear: () => {}, max: MAX, full: false };
  return ctx;
}
